import { DiagnosisSeverity, LlmDiagnosisFlag, LlmDiagnosisStatus } from "../types/llm-diagnosis";

export const ACTIONABLE_GOOGLE_DIAGNOSIS_IDS = [
  "GD11",
  "GD12",
  "G21",
  "G22",
  "G26",
  "G27",
  "G31",
  "G36",
  "G39",
  "G42",
  "G46",
  "G47",
  "G50",
  "G54",
  "G55",
  "G56",
  "G58",
  "G-AD2",
  "G-CT3",
  "G-DG3",
  "G-PM7",
] as const;

export const ACTIONABLE_META_DIAGNOSIS_IDS = [
  "MD08",
  "MD09",
  "M13",
  "M14",
  "M22",
  "M23",
  "M-ST6",
  "M-ST7",
  "M-ST8",
  "M-AU7",
  "M-AU8",
] as const;

const ACTIONABLE_DIAGNOSIS_IDS = new Set<string>([
  ...ACTIONABLE_GOOGLE_DIAGNOSIS_IDS,
  ...ACTIONABLE_META_DIAGNOSIS_IDS,
]);

export const isActionableDiagnosis = (diagnosisId: string): boolean =>
  ACTIONABLE_DIAGNOSIS_IDS.has(diagnosisId);

export const getSeverityClass = (flag: string | null): string => {
  if (flag === DiagnosisSeverity.FAILURE) return 'failure';
  if (flag === DiagnosisSeverity.HIGH) return 'high';
  if (flag === DiagnosisSeverity.MEDIUM) return 'medium';
  if (flag === DiagnosisSeverity.LOW) return 'low';
  return 'low';
};

export const getSeverityLabel = (flag: string | null): string => {
  if (flag === DiagnosisSeverity.FAILURE) return '失敗';
  if (flag === DiagnosisSeverity.HIGH) return '緊急';
  if (flag === DiagnosisSeverity.MEDIUM) return '注意';
  if (flag === DiagnosisSeverity.LOW) return '確認';
  return '確認';
};

export const diagnosisStatusLabel = (status: LlmDiagnosisStatus): string => {
  if (status === "open") return "未対応";
  if (status === "monitoring") return "監視中";
  if (status === "blocked") return "要確認";
  return "未対応";
};
